import Expand from '@alltrails/shared/icons/Expand';
import IconButton from '@alltrails/shared/denali/components/IconButton';

type ViewMapButtonProps = {
  href: string;
  title: string;
};

const ViewMapButton = ({ href, title }: ViewMapButtonProps) => (
  <IconButton icon={{ Component: Expand }} linkInfo={{ href, rel: ['nofollow'] }} title={title} size="sm" testId="view-map" variant="elevated" />
);

export default ViewMapButton;
